import { graphql } from "relay-runtime"

export const ChatThreadItemFragment = graphql`
  fragment ChatThreadItemFragment on Appointment {
    chat {
      readState {
        ...ChatReadStateFragment @relay(mask: false)
      }
      lastMessage {
        ...ChatLastMessageFragment @relay(mask: false)
      }
      greeting {
        ...ChatGreetingFragment @relay(mask: false)
      }
    }
  }
`
